export const removeNonNumeric = (value: string) => value.replace(/\D/g, '')

export const sanitizeCnpj = (value: string) =>
  value.replace(/[^0-9A-Za-z]/g, '').toUpperCase()

export const CNPJ_IMASK_OPTS = {
  mask: '@@.@@@.@@@/@@@@-00',
  definitions: {
    '@': /[0-9A-Za-z]/,
  },
  prepare: (str: string) => str.toUpperCase(),
}

export const capitalize = (string: string) =>
  string[0].toUpperCase() + string.slice(1)
